<template>
    <div>
        <div class="col-md-12">
            <div class="card abtg__default-card abtg__default-card-border">
                <div class="card-head">
                    <header> </header>
                </div>
                <div class="card-body ">

                    <!-- <div class="row">
                                            <div class="col">
                                                <h1 style="color:green">€ {{content.packListData.bigTotal}}</h1>
                                                <h4>Sinkronia: € <strong>{{content.packListData.lifePrice + content.packListData.annualPrice + content.packListData.monthlyPrice}} </strong>
                                                | ABTG: € <strong>{{content.packListData.abtgLife + content.packListData.abtgAnnual + content.packListData.abtgMonthly}}</strong>


                                                </h4>
                                                <hr>
                                            </div>

                                        </div>-->

                <!--    <div class="row">
                        <div class="col abtg__back_money"><p>Account Life: {{content.packListData.totLife}}</p>
                                        <div class="row">
                                            <div class="col">
                                                <strong>Sinkronia</strong>
                                                <p> € <span style="color:green">{{content.packListData.lifePrice}}</span></p>
                                            </div>
                                            <div class="col">
                                                <strong>ABTG</strong>
                                                <p> € <span style="color:green">{{content.packListData.abtgLife}}</span></p>

                                            </div>
                                        </div>
                        </div>
                        <div class="col abtg__back_money"><p>Account Annual: {{content.packListData.totAnnual}}</p>
                            <div class="row">
                                <div class="col"><strong>Sinkronia</strong>
                                    <p>€ <span style="color:green">{{content.packListData.annualPrice}}</span> </p></div>
                                <div class="col"><strong>ABTG</strong>
                                    <p>€ <span style="color:green">{{content.packListData.abtgAnnual}}</span> </p>
                                </div>
                            </div>

                        </div>
                        <div class="col abtg__back_money">
                            <p>Account Monthly: {{content.packListData.totMonthly}}</p>
                            <div class="row">
                                <div class="col">
                                    <strong>Sinkronia</strong>
                                    <p>€ <span style="color:green">{{content.packListData.monthlyPrice}}</span></p>
                                </div>
                                <div class="col">
                                    <strong>ABTG</strong>
                                    <p>€ <span style="color:green">{{content.packListData.abtgMonthly}}</span></p>

                                </div>
                            </div>
                        </div>
                    </div>-->


                 <!--   <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Email</th>
                                <th>Pack</th>
                                <th>Creato</th>
                                <th>Pagato il</th>
                                <th>ESTRATTO</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td colspan="5"><strong>LIFETIME</strong></td>
                        </tr>
                        <tr v-for="(p, index) in filteredBuyerLifeTime">
                            <td>{{index + 1}}</td>
                            <td>{{p.email}} </td>
                            <td>{{p.pack}}</td>
                            <td>{{p.created_at}}</td>
                            <td></td>
                            <td>
                                <span v-if="p.report">
                                    ( {{p.report.email}} )<br>
                                    {{p.report.prodotto}}<br>
                                    {{p.report.prezzo_netto}}

                                </span>
                                <span v-else>N.d.</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5"><strong>ANNUALE</strong></td>
                        </tr>
                        <tr v-for="(p, index) in filteredBuyerAnnual">
                            <td>{{index + 1}}</td>
                            <td>{{p.email}}</td>
                            <td>{{p.pack}}</td>
                            <td>{{p.created_at}}</td>
                            <td></td>
                            <td>
                                <span v-if="p.report">
                                    ( {{p.report.email}} )<br>
                                    {{p.report.prodotto}}<br>
                                    {{p.report.prezzo_netto}}

                                </span>
                                <span v-else>N.d.</span>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="5"><strong>MENSILE </strong></td>
                        </tr>
                        <tr v-for="(p, index) in filteredBuyerMonthly">
                            <td>{{index + 1}}</td>
                            <td>{{p.email}}</td>
                            <td>{{p.pack}}</td>
                            <td>{{p.created_at}}</td>
                            <td></td>
                            <td>
                                <span v-if="p.report">
                                    ( {{p.report.email}} )<br>
                                    {{p.report.prodotto}}<br>
                                    {{p.report.prezzo_netto}}

                                </span>
                                <span v-else>N.d.</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>-->


                </div>
                <div class="card-footer">
                    <div class="float-right">

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mixin} from '../../helpers/helper'


    export default {
        mixins: [mixin],
        props: ['content'],
        components: { },
        data: function () {
            return {
            }
        },

        computed: {
                filteredBuyerLifeTime: function()
                {
                    if(this.content.packListData.pack)
                    {
                        return this.content.packListData.pack.filter(function(value){
                            return value.pack === 'Real Estate Pro Lifetime';
                        })
                    }

                    return;
                },

            filteredBuyerAnnual: function()
            {
                if(this.content.packListData.pack)
                {
                    return this.content.packListData.pack.filter(function(value){
                        return value.pack === 'Real Estate Pro Annuale';
                    })
                }

                return;
            },
            filteredBuyerMonthly: function()
            {
                if(this.content.packListData.packMonthly)
                {
                    return this.content.packListData.packMonthly.filter(function(value){
                        return value.pack === 'Real Estate Pro Mensile';
                    })
                }

                return;
            }
        },
        created: function () {
        },
        methods: {
        }
    }
</script>
